/* 
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {
  dateToMoment,
  getDaysFromToday,
  getYesterday,
  today
} from '@ion/core/src/utils/DateUtil';
import {DateSelectorValues} from '../../types/types';

export const getDateRangeFromValue = (radioValue, fromToday: boolean = false): any => {
  switch (radioValue) {
    case DateSelectorValues.Today:
      return dateToMoment(today());
    case DateSelectorValues.Yesterday :
      return dateToMoment(getYesterday());
    case DateSelectorValues.LastSeven :
      return getDaysFromToday(7, 'subtract', {fromToday});
    case DateSelectorValues.LastThirty :
      return getDaysFromToday(30, 'subtract', {fromToday});
    case DateSelectorValues.Live :
      return {
        startDate : null,
        endDate   : null
      };
    default :
      return {
        fromDate : radioValue[0],
        toDate   : radioValue[1]
      };
  }
};
